import { render, staticRenderFns } from "./booking-instructions.vue?vue&type=template&id=3df8f9ad"
import script from "./booking-instructions.vue?vue&type=script&lang=js"
export * from "./booking-instructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports